import {ReactNode} from "react"; 
import Sidebar from "./Sidebar"; 

interface PropsLayout {
    children: ReactNode; 
}

export default function Layout ({children}: PropsLayout){
    return (
        <div className="flex h-screen bg-gray-50">
            <Sidebar/>
            <main className="flex-1 overflow-y-auto p-8">
                {children}
            </main>
        </div>
    ); 
}